import { render, staticRenderFns } from "./EditClinicianStaffReferralDetails.vue?vue&type=template&id=ac133b0c&"
import script from "./EditClinicianStaffReferralDetails.vue?vue&type=script&lang=js&"
export * from "./EditClinicianStaffReferralDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditClinicianStaffReferralDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports